//check the given color is related to white
export function isWhite(str: string) {
  var whiteLimit = 200,
    r,
    g,
    b;

  r = parseInt("0x" + str.substring(1, 3));
  g = parseInt("0x" + str.substring(3, 5));
  b = parseInt("0x" + str.substring(5, 7));
  if (r < whiteLimit || b < whiteLimit || g < whiteLimit) {
    return false;
  }
  return true;
}
